import { cn } from '@/lib/utils';

export function Skeleton({ className, testid = 'skeleton', ...props }) {
  return (
    <div
      data-testid={testid}
      className={cn(
        'bg-[var(--fill-tertiary)] rounded-md animate-pulse',
        className
      )}
      {...props}
    />
  );
}
